import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { setAlert } from '../../../../../actions/alert';
import { crearUbicacionConfiguracion } from '../../../../../actions/configuracion';

const NuevaUbicacion = ({ ubicacion, reestablecerUbicacion }) => {

    const dispatch =  useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [ubicacionData, setUbicacionData] = useState({
        id: null,
        nombre: null
    });

    /* Crear ubicacion */
    const handleInputChange = ({ target }) => {
        setUbicacionData({
            ...ubicacionData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(ubicacionData.nombre && ubicacionData.id != 0 && ubicacionData.id != '0'){
            await setStatusProcesar(true);
            await dispatch(crearUbicacionConfiguracion(ubicacionData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setUbicacionData({
                id: null,
                nombre: null
            });

            setNuevoModal(false);
            reestablecerUbicacion(null);
        }
    }

    useEffect(() => {
        if(ubicacion){
            setNuevoModal(true);

            setUbicacionData({
                ...ubicacionData, 
                id: ubicacion.id_organizador
            });
        }        
    }, [ubicacion]);

    return (
        <Modal show={nuevoModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar ubicación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={ubicacionData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevaUbicacion;